import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UpdateLicensePlateAPI } from "api/reservationAPI";
import { UpdateSpaceNumberAPI } from "api/reservationAPI";
import { GetReservationsStatisticsAPI } from "api/reservationAPI";
import { GetReservationsByPlaceIdAPI } from "api/reservationAPI";
import { GetVehicleCheckLogsAPI } from "api/reservationAPI";
import { get } from "lodash";


const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  reservationsList: [],
  totalReservations: 0,
  statistics: {},
  lpDetails: [],
  activityLogs: [],
  loading: false,
};

export const getReservations = createAsyncThunk(
  "reservations/getReservations",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetReservationsByPlaceIdAPI(data);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getReservationStatistics = createAsyncThunk(
  "reservations/getReservationStatistics",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetReservationsStatisticsAPI(data);
      return response.data;
    } catch (err) {
      console.log("Get reservation statistics ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const updateLicensePlate = createAsyncThunk(
  "reservations/updateLicensePlate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await UpdateLicensePlateAPI(data);
      return response.data;
    } catch (err) {
      console.log("edit licensePlate error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);
export const updateSpaceNumber = createAsyncThunk(
  "reservations/updateSpaceNumber",
  async (data, { rejectWithValue }) => {
    try {
      const response = await UpdateSpaceNumberAPI(data);
      return response.data;
    } catch (err) {
      console.log("edit space number error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);
export const getVehicleCheckLogs = createAsyncThunk(
  "reservations/getVehicleCheckLogs",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GetVehicleCheckLogsAPI(params); 
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  },
);
export const reservationSlice = createSlice({
  name: "reservations",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getReservations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReservations.fulfilled, (state, { payload }) => {
        state.reservationsList = get(payload, "reservations", []);
        state.totalReservations = get(payload, "total", 0);
        state.loading = false;
      })
      .addCase(getReservations.rejected, (state) => {
        state.qrCodeListLoading = false;
      })
      .addCase(getReservationStatistics.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReservationStatistics.fulfilled, (state, { payload }) => {
        state.statistics = get(payload, "statistics", {});
        state.loading = false;
      })
      .addCase(getReservationStatistics.rejected, (state) => {
        state.qrCodeListLoading = false;
      })
      .addCase(getVehicleCheckLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleCheckLogs.fulfilled, (state, { payload }) => {
        state.activityLogs = get(payload, "data", []);
        state.total = get(payload, "total", 0);
        state.loading = false;
      })
      .addCase(getVehicleCheckLogs.rejected, (state) => {
        state.loading = false;
      }),
});

export default reservationSlice.reducer;
